import { gsap, ScrollTrigger } from "@gsap";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
/**
 * Layout: Verhaal - Slider
 * Slug: verhaal_slider
 */

document.addEventListener("DOMContentLoaded", function () {
	gsap.registerPlugin(ScrollTrigger);
	const layouts = document.querySelectorAll(
		".flex-layout.verhaal_slider-layout",
	);

	layouts.forEach((layout) => {
		const slider = layout.querySelector(".swiper-container");
		return new Swiper(slider, {
			slidesPerView: 1.125,
			spaceBetween: 16,
			navigation: {
				nextEl: layout.querySelector(".slider-button-next"),
				prevEl: layout.querySelector(".slider-button-prev"),
			},
			breakpoints: {
				768: {
					slidesPerView: 2.25,
					spaceBetween: 24,
				},
				1024: {
					slidesPerView: 3
				}
			},
			on: {
				afterInit: (self) => {
					gsap.from(self.slides, {
						y: -20,
						opacity: 0,
						stagger: 0.1,
						scrollTrigger: {
							trigger: slider
						}
					})
				}
			}
		});
	});
});
